export default "__VITE_ASSET__77044eee__"